import { render, staticRenderFns } from "./dataSorce.vue?vue&type=template&id=8e2924a8&"
import script from "./dataSorce.vue?vue&type=script&lang=js&"
export * from "./dataSorce.vue?vue&type=script&lang=js&"
import style0 from "./dataSorce.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports